import { generateMetadata, MetaDataEntity } from './utils'

const MetaData: MetaDataEntity = {
  title: 'AviaGames | Terms of Service',
  description: "Review Avia's Terms of Service to understand user rights, responsibilities, and guidelines and more.",
  keywords: ['terms of service'],
  path: '/terms-service',
}

export const TermsServiceMetaData = generateMetadata(MetaData)
